import { fetchDataFromApi } from './handleApiRequest'
import { getEnvironment } from '../appUtils'

export function handleUniqueHash(apis, success, error) {
  // for testing errors
  // const ZD_FORMS_UNIQUE_HASH = 'http://localhost:4000/api/feedback-form-unique-hash-error.json'

  const url = apis[getEnvironment('ZD_FORMS_UNIQUE_HASH')]
  const key = apis[getEnvironment('ZD_API_PROXY_AUTHORISATION_KEY')]

  const headers = { 'api-authorisation-key': key }

  fetchDataFromApi({ url, headers })
    .then((response) => {
      success(response)
    })
    .catch((response) => {
      error(response)
    })
}

export function handlePostFeedback(apis, data, success, error) {
  // for testing errors
  // const ZD_FORMS_POST_ENTITY = 'http://localhost:4000/api/feedback-form-post-error.json'

  let url = apis[getEnvironment('ZD_FORMS_POST_ENTITY')]
  const key = apis[getEnvironment('ZD_API_PROXY_AUTHORISATION_KEY')]

  url = url.replace(/%FORM_ID%/g, data.form)
  let headers = { 'api-authorisation-key': key, 'content-type': 'application/x-www-form-urlencoded' }

  const formData = new FormData()
  for (const key in data) {
    formData.append(key, data[key])
  }

  fetchDataFromApi({ method: 'post', url, headers, data: formData })
    .then((response) => {
      success(response)
    })
    .catch((response) => {
      error(response)
    })
}
